import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Loading } from "common-import/custom";
import { VarHelper } from "common-import/helpers";
import {TicketStatus} from "../../services/ticket/Ticket.Constant";
import {isEmpty} from "lodash";
import {Link} from "react-router-dom";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("userStore", "ticketStore", "contractorStore") @observer
export default class TicketDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: {},
      ticket: {},
      user: {},
      contractor: {},
      isClaiming: false,
      isSaving: false,
      isLoading: true,
    }
  };

  componentDidMount = async () => {
    const { userStore, ticketStore, match } = this.props;
    await userStore.onReady();
    const res = await ticketStore.detail({id: match.params.id});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({current: res.data, ticket: res.data, isLoading: false});
    this.getUserDetail();
    this.getContractorDetail();
  };

  getUserDetail = async () => {
    const { current } = this.state;
    const { userStore } = this.props;
    const res = await userStore.getUserDetailById(current.createdByUserId);
    if (!!res.error) return window.toast.error("Can not get USER info");
    this.setState({user: res.data});
  };

  getContractorDetail = async () => {
    const { current } = this.state;
    const { contractorStore } = this.props;
    const res = await contractorStore.detail(current.objectId);
    if (!!res.error) return window.toast.error("Can not get CONTRACTOR info");
    this.setState({contractor: res.data});
  };

  handleClaim = async (e) => {
    !!e && e.preventDefault();
    const { ticketStore, match } = this.props;
    if (!window.confirm("Are you sure want to CLAIM " + match.params.id)) return null;
    const payload = {
      id: match.params.id,
      status: TicketStatus.CLAIM_SUCCESSFUL,
    };
    const res = await ticketStore.updateClaim(payload);
    if (!!res.error) return window.error("Error: ", JSON.stringify(res.error));
    return window.toast.info("CLAIMED successfully!");
  };

  handleReject = async (e) => {
    !!e && e.preventDefault();
    const { ticketStore, match } = this.props;
    if (!window.confirm("Are you sure want to REJECT " + match.params.id)) return null;
    const payload = {
      id: match.params.id,
      status: TicketStatus.CLAIM_REJECT,
    };
    const res = await ticketStore.update(payload);
    if (!!res.error) return window.error("Error: ", JSON.stringify(res.error));
    return window.toast.info("REJECTED successfully!");
  };

  renderButtons = () => {
    const { current } = this.state;
    return (
      <div className="button-group">
        {
          current.status === TicketStatus.CLAIM_SUCCESSFUL ? '' :
            <button className="btn btn-sm btn-primary" onClick={e => this.handleClaim(e)}>
              <i className="fa fa-dot-circle-o"> </i>  Approve
            </button>
        }
        {
          current.status !== TicketStatus.CLAIM_SUCCESSFUL ?
            <button className="btn btn-sm btn-danger" onClick={e => this.handleReject(e)}>
              <i className="fa fa-ban"> </i>  Reject
            </button>
            : ''
        }
        <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
          <i className="fa fa-long-arrow-left"> </i> Go back
        </button>
      </div>
    )
  };

  render() {
    const { isLoading, current, user, contractor } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn" id="ticket-detail-page">
        <div className="card">
          <div className="card-header">
            {this.renderButtons()}
          </div>
          <div className="card-body">
            <div className="block-content">
              <h4 className="block-content__title">User & Contractor</h4>
              <div className="row mr-8">
                <div className="col-md-6">
                  {
                    !user || isEmpty(user) ? '' :
                      <div className="chip">
                        <img src={user.avatar || defaultImage} alt="" />
                        <Link target="_blank" to={`/user/${user.id}`}>{user.name || "Anonymous"}</Link>
                      </div>
                  }
                </div>
                <div className="col-md-6">
                  {
                    !contractor || isEmpty(contractor) ? '' :
                      <div className="chip">
                        <img src={contractor.logo || defaultImage} alt="" />
                        <Link target="_blank" to={`/contractor/${contractor.id}`}>{contractor.name || "Anonymous"}</Link>
                      </div>
                  }
                </div>
              </div>
            </div>
            <div className="block-content">
              <h4 className="block-content__title">Content & Attachments</h4>
              <div className="row">
                <div className="col-md-6">
                  <h5 className="mb-16">{current.content}</h5>
                </div>
                <div className="col-md-6">
                  {
                    (() => {
                      if (!!current.attachments && !isEmpty(current.attachments)) {
                        return (
                          <div className="ticket-attach">
                            {
                              current.attachments.map((item, index) => {
                                return <a key={"attach-"+index} className="mr-8" href={VarHelper.img(item.url)} target="_blank"><i className="fa fa-paperclip"> </i> {item.name}</a>
                              })
                            }
                          </div>
                        )
                      }
                    })()
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            {this.renderButtons()}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Ticket/TicketDetail.js